import { useEffect, useState } from "react";
import { connect } from "react-redux";

//Import CONFIG
import {
  MAX_NUMBER,
  MAX_RANDOM_NUMBERS,
  MENU_POPUPS,
  RESULTS_POPUP_CLOSE_DEELAY,
} from "../../config/Game";

//Import CORE
import {
  __ConnectionManager,
  __CurrentConnection,
  __EventDispatcher,
  __Lang,
  __Store,
  __Utils,
} from "../../../_core/core";

//Import STORE
import {
  action_cleanSelectedNumbers,
  action_setCurrentTicket,
  action_setGameplayData,
  action_setSelectedNumbers,
} from "../../../_core/store/actions/actions.Game";
import { store } from "../../../_core/core.Store";

//Import COMPONENTS
import DrawInfo from "./Draw.info";
import DrawGrid from "./Draw.grid";
import DrawActions from "./Draw.actions";
import DrawWin from "./Draw.win";
import { setGameplayData } from "../../../_core/store/slices/slice.Game";
import { SND_PLAY } from "../../../_core/core.SoundManager";
import { EventClass, EventType } from "../../config/Events";
import { Logger, LoggerEnums } from "../../../_core/core.Logger";

const Draw = (_props: any) => {
  const [winNumbers, setWinNumbers] = useState<any[]>([]);
  const [isStart, setIsStart] = useState<boolean>(false);

  const clearNumberSelection = () => {
    action_cleanSelectedNumbers()(store.dispatch);
  };

  const actionSuffle = () => {
    let _numbers = __Utils.randGenerateArr(MAX_RANDOM_NUMBERS, MAX_NUMBER);

    action_cleanSelectedNumbers()(store.dispatch);
    action_setSelectedNumbers(_numbers)(store.dispatch);
  };

  const actionNewCard = () => {
    action_setCurrentTicket(null)(store.dispatch);
  };

  const closeCurrentDraw = () => {
    // return;
    setTimeout(() => {
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.POPUP_RESULTS,
      });
    }, 2500);

    setTimeout(() => {
      __CurrentConnection.rgsInit(sessionID);
      __CurrentConnection.getBets();
      __CurrentConnection.updateBalance();
      __CurrentConnection.failedBets();

      setWinNumbers((_winNumbers) => []);

      store.dispatch(
        setGameplayData({
          drawResults: [],
          drawedNumbers: [],
          drawStart: false,
          drawEnds: false,
        })
      );
      store.dispatch(action_setCurrentTicket(null));
    }, RESULTS_POPUP_CLOSE_DEELAY + 2500);

    setIsStart(false);
    const { sessionID } = __Store.getState().game.SESSION_DATA;
  };

  const getLastResults = () => {
    __CurrentConnection.lastResults();
  };

  const playSound = (_currentNumber: number) => {
    const lState = store.getState();
    const currentTicket = lState.game.GAMEPLAY.currentTicket;
    const selectedNumbers = lState.game.GAMEPLAY.selectedNumbers;

    if (!currentTicket) {
      SND_PLAY("BALL_MISS");
      return;
    }

    if (
      Object.entries(selectedNumbers).length &&
      typeof selectedNumbers[_currentNumber] !== "undefined"
    ) {
      SND_PLAY("BALL_MATCH");
      return;
    }

    SND_PLAY("BALL_MISS");
  };

  const onEventDispatched = (
    _eventClass: EventClass,
    _eventType: string,
    _eventPayload?: any
  ) => {
    if (
      _eventClass !== EventClass.SYSTEM &&
      _eventClass !== EventClass.GAMEPLAY
    )
      return false;

    switch (_eventType) {
      case EventType.SYSTEM.FOCUS_CHANGED:
        if (_eventPayload.bFocused) {
          const { sessionID } = __Store.getState().game.SESSION_DATA;
          const { timer } = __Store.getState().game.GAMEPLAY;
          const { drawStart } = __Store.getState().game.GAMEPLAY;
          const { idleTime } = __Store.getState().game.GAMEPLAY;

          let idleSeconds = (new Date().getTime() - idleTime) / 1000;

          if (__ConnectionManager.isActive()) {
          } else {
            __ConnectionManager.handleRedirect(0);
          }

          if (timer <= 0) {
            if (idleSeconds >= 5 && drawStart === false) {
              __CurrentConnection.lastResults();
            }

            if (idleSeconds >= 30) {
              __CurrentConnection.lastResults();
            }
          }

          if (timer > 0 && drawStart === false) {
            __CurrentConnection.rgsInit(sessionID);
          }
          Logger({
            type: LoggerEnums.EXPECTED,
            errorMessage: `Idle Seconds: ${idleSeconds}`,
          });
        } else {
          store.dispatch(
            action_setGameplayData({
              idleTime: new Date().getTime(),
            })
          );
        }
        __EventDispatcher.removeListener(EventClass.SYSTEM, () => {}, this);
        break;
      case EventType.GAMEPLAY.ROUND_END:
        store.dispatch(action_setCurrentTicket(_eventPayload.tickets[0]));
        __EventDispatcher.removeListener(EventClass.GAMEPLAY, () => {}, this);
        break;
    }
  };

  //on mounted
  useEffect(() => {
    actionSuffle();
    __EventDispatcher.addListener(EventClass.SYSTEM, onEventDispatched, this);
    __EventDispatcher.addListener(EventClass.GAMEPLAY, onEventDispatched, this);
  }, []);

  //check if a lottery starts
  useEffect(() => {
    if (_props.GAMEPLAY.drawStart) {
      setIsStart(true);
      //if draw started and the game is on first screen
      if (!_props.GAMEPLAY.currentTicket) {
        //if draw started clean all numbers
        store.dispatch(action_setSelectedNumbers([]));
        //if draw started & we have placed tickets jump to first ticket
        if (
          _props.GAMEPLAY.tickets.length &&
          __Utils.isSet(_props.GAMEPLAY.tickets[0])
        ) {
          store.dispatch(action_setCurrentTicket(_props.GAMEPLAY.tickets[0]));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.GAMEPLAY.drawStart]);

  //lottery ends
  useEffect(() => {
    if (_props.GAMEPLAY.drawEnds) {
      closeCurrentDraw();
    }
  }, [_props.GAMEPLAY.drawEnds]);

  let i = 0;
  let _drawInterval: any = null;
  useEffect(() => {
    let _results = _props.GAMEPLAY.drawResults;
    if (!_results.length || !isStart) {
      clearInterval(_drawInterval);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _drawInterval = setInterval(() => {
      i++;
      setWinNumbers((_winNumbers) => [..._winNumbers, _results[i - 1]]);
      playSound(_results[i - 1]);

      let _drawedNumbers = store.getState().game.GAMEPLAY.drawedNumbers;

      store.dispatch(
        setGameplayData({
          drawedNumbers: [..._drawedNumbers, _results[i - 1]],
        })
      );

      if (i >= _results.length) {
        clearInterval(_drawInterval);
        getLastResults();
      }
    }, 1000);

    return () => {
      // if(_drawInterval)
      //   clearInterval(_drawInterval);
    };
  }, [isStart]);

  // const generateRandomDraw = () => {
  //   let numbers = __Utils.randGenerateArr(30, MAX_NUMBER);
  //   store.dispatch(
  //     setGameplayData({
  //       drawResults: numbers,
  //       drawStart: true,
  //     })
  //   );
  // };

  return (
    <div className="gameplay-container">
      <DrawInfo />
      {/* <button onClick={ () => generateRandomDraw()}>Generate draw</button> */}{" "}
      <div className="game-board">
        <DrawGrid />
        <DrawWin winningNumbers={winNumbers} />

        {_props.GAMEPLAY.timer <= 0 && !_props.GAMEPLAY.drawStart ? (
          <div className="please-wait">
            <i className="fas fa-spinner fa-spin"></i>
            {__Lang.translate("n:play.pleaseWait")}
          </div>
        ) : (
          ""
        )}
      </div>
      <DrawActions
        actionSuffle={actionSuffle}
        actionClear={clearNumberSelection}
        actionNewCard={actionNewCard}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY,
    STATUS_DATA: state.game.STATUS_DATA,
  };
};

export default connect(mapStateToProps, {})(Draw);
